import React from "react";
import { View } from "react-native";
import { uniqueId } from "lodash";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function ReflectionEmptyPageIcon(props) {
  const filterId = "clip0" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style} {...props}>
      <Svg
        width="281"
        height="209"
        viewBox="0 0 281 209"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMax slice"
      >
        <G clipPath={filterUrl}>
          <Path
            d="M97.8916 64.083H134.04"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M54.8268 103.979C56.782 98.8637 57.0652 94.2192 55.4593 93.6054C53.8534 92.9916 50.9666 96.6409 49.0114 101.756C47.0562 106.872 46.773 111.516 48.3789 112.13C49.9848 112.744 52.8716 109.094 54.8268 103.979Z"
            fill="#2F2E41"
          />
          <Path
            d="M278.98 127.849C282.913 157.116 277.558 186.416 250.32 197.825C223.083 209.234 191.753 196.402 180.344 169.165C168.935 141.927 195.854 125.63 209.004 99.1887C235.708 45.4948 266.768 36.959 278.98 127.849Z"
            fill="#F2F2F2"
          />
          <Path
            d="M229.945 205.234C253.514 205.234 272.62 202.635 272.62 199.428C272.62 196.222 253.514 193.623 229.945 193.623C206.376 193.623 187.27 196.222 187.27 199.428C187.27 202.635 206.376 205.234 229.945 205.234Z"
            fill="#3F3D56"
          />
          <Path
            d="M202.027 184.653L203.632 190.46L214.037 187.584L212.431 181.777L202.027 184.653Z"
            fill="#2F2E41"
          />
          <Path
            d="M202.745 191.486C203.747 191.209 203.961 188.818 203.222 186.146C202.483 183.473 201.072 181.531 200.07 181.808C199.067 182.085 198.854 184.476 199.593 187.149C200.331 189.822 201.743 191.764 202.745 191.486Z"
            fill="#2F2E41"
          />
          <Path
            d="M234.867 164.681C235.602 159.254 234.818 154.668 233.114 154.437C231.41 154.206 229.433 158.418 228.698 163.845C227.962 169.271 228.747 173.858 230.45 174.089C232.154 174.32 234.131 170.108 234.867 164.681Z"
            fill="#2F2E41"
          />
          <Path
            d="M229.841 202.657C240.793 202.657 249.672 193.778 249.672 182.826C249.672 171.873 240.793 162.994 229.841 162.994C218.888 162.994 210.009 171.873 210.009 182.826C210.009 193.778 218.888 202.657 229.841 202.657Z"
            fill="#2F2E41"
          />
          <Path
            d="M202.027 181.138L203.632 186.945L214.037 184.069L212.431 178.262L202.027 181.138Z"
            fill="#2F2E41"
          />
          <Path
            d="M202.745 187.972C203.747 187.695 203.961 185.304 203.222 182.631C202.483 179.959 201.072 178.017 200.07 178.294C199.067 178.571 198.854 180.962 199.593 183.635C200.331 186.307 201.743 188.249 202.745 187.972Z"
            fill="#2F2E41"
          />
          <Path
            d="M235.048 178.243C238.792 178.243 241.826 175.208 241.826 171.465C241.826 167.722 238.792 164.687 235.048 164.687C231.305 164.687 228.271 167.722 228.271 171.465C228.271 175.208 231.305 178.243 235.048 178.243Z"
            fill="white"
          />
          <Path
            d="M237.216 170.73C238.464 170.73 239.475 169.718 239.475 168.471C239.475 167.223 238.464 166.211 237.216 166.211C235.968 166.211 234.957 167.223 234.957 168.471C234.957 169.718 235.968 170.73 237.216 170.73Z"
            fill="#3F3D56"
          />
          <Path
            d="M252.742 196.455C260.081 196.087 265.702 189.223 265.296 181.123C264.891 173.022 258.613 166.753 251.274 167.121C243.935 167.488 242.784 173.249 243.189 181.349C243.595 189.45 245.404 196.822 252.742 196.455Z"
            fill="#239C9D"
          />
          <Path
            d="M221.736 174.435C220.542 174.531 219.358 174.149 218.445 173.373C217.532 172.597 216.965 171.49 216.869 170.295C216.772 169.101 217.154 167.917 217.93 167.004C218.706 166.091 219.813 165.524 221.007 165.427C223.494 165.226 224.173 167.2 224.374 169.688C224.575 172.175 224.223 174.233 221.736 174.435Z"
            fill="white"
          />
          <Path
            d="M12.417 90.6288H123.497L140.718 99.0188L168.158 112.387L186.098 78.7957H236.867"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M55.933 97.5787C57.8304 97.5787 59.3685 96.0406 59.3685 94.1432C59.3685 92.2459 57.8304 90.7078 55.933 90.7078C54.0357 90.7078 52.4976 92.2459 52.4976 94.1432C52.4976 96.0406 54.0357 97.5787 55.933 97.5787Z"
            fill="#239C9D"
          />
          <Path
            d="M87.997 94.0633C89.8943 94.0633 91.4324 92.5252 91.4324 90.6278C91.4324 88.7305 89.8943 87.1924 87.997 87.1924C86.0996 87.1924 84.5615 88.7305 84.5615 90.6278C84.5615 92.5252 86.0996 94.0633 87.997 94.0633Z"
            fill="#239C9D"
          />
          <Path
            d="M140.674 102.462C142.571 102.462 144.109 100.924 144.109 99.0263C144.109 97.1289 142.571 95.5908 140.674 95.5908C138.776 95.5908 137.238 97.1289 137.238 99.0263C137.238 100.924 138.776 102.462 140.674 102.462Z"
            fill="#239C9D"
          />
          <Path
            d="M214.727 82.2303C216.625 82.2303 218.163 80.6922 218.163 78.7948C218.163 76.8975 216.625 75.3594 214.727 75.3594C212.83 75.3594 211.292 76.8975 211.292 78.7948C211.292 80.6922 212.83 82.2303 214.727 82.2303Z"
            fill="#239C9D"
          />
          <Path
            d="M178.846 95.5907C180.743 95.5907 182.282 94.0525 182.282 92.1552C182.282 90.2578 180.743 88.7197 178.846 88.7197C176.949 88.7197 175.411 90.2578 175.411 92.1552C175.411 94.0525 176.949 95.5907 178.846 95.5907Z"
            fill="#239C9D"
          />
          <Path
            d="M107.335 149.664C109.381 149.664 111.039 148.005 111.039 145.96C111.039 143.914 109.381 142.256 107.335 142.256C105.289 142.256 103.631 143.914 103.631 145.96C103.631 148.005 105.289 149.664 107.335 149.664Z"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M42.6754 208.999C66.2444 208.999 85.3508 206.4 85.3508 203.194C85.3508 199.987 66.2444 197.388 42.6754 197.388C19.1064 197.388 0 199.987 0 203.194C0 206.4 19.1064 208.999 42.6754 208.999Z"
            fill="#3F3D56"
          />
          <Path
            d="M40.3667 194.659C51.3193 194.659 60.1982 185.78 60.1982 174.828C60.1982 163.875 51.3193 154.996 40.3667 154.996C29.414 154.996 20.5352 163.875 20.5352 174.828C20.5352 185.78 29.414 194.659 40.3667 194.659Z"
            fill="#2F2E41"
          />
          <Path
            d="M37.3544 190.392H31.3296V201.186H37.3544V190.392Z"
            fill="#2F2E41"
          />
          <Path
            d="M49.4042 190.392H43.3794V201.186H49.4042V190.392Z"
            fill="#2F2E41"
          />
          <Path
            d="M36.3502 203.194C39.123 203.194 41.3709 202.351 41.3709 201.311C41.3709 200.271 39.123 199.428 36.3502 199.428C33.5774 199.428 31.3296 200.271 31.3296 201.311C31.3296 202.351 33.5774 203.194 36.3502 203.194Z"
            fill="#2F2E41"
          />
          <Path
            d="M48.4 202.943C51.1729 202.943 53.4207 202.1 53.4207 201.06C53.4207 200.02 51.1729 199.177 48.4 199.177C45.6272 199.177 43.3794 200.02 43.3794 201.06C43.3794 202.1 45.6272 202.943 48.4 202.943Z"
            fill="#2F2E41"
          />
          <Path
            d="M40.8687 176.585C44.612 176.585 47.6465 173.55 47.6465 169.807C47.6465 166.064 44.612 163.029 40.8687 163.029C37.1254 163.029 34.0908 166.064 34.0908 169.807C34.0908 173.55 37.1254 176.585 40.8687 176.585Z"
            fill="white"
          />
          <Path
            d="M40.8692 172.066C42.1169 172.066 43.1284 171.054 43.1284 169.807C43.1284 168.559 42.1169 167.547 40.8692 167.547C39.6214 167.547 38.6099 168.559 38.6099 169.807C38.6099 171.054 39.6214 172.066 40.8692 172.066Z"
            fill="#3F3D56"
          />
          <Path
            d="M21.1301 156.385C19.5288 149.213 24.6475 141.967 32.5631 140.2C40.4787 138.432 48.1936 142.813 49.7949 149.984C51.3962 157.156 46.1503 159.8 38.2347 161.568C30.3192 163.335 22.7314 163.556 21.1301 156.385Z"
            fill="#239C9D"
          />
          <Path
            d="M33.5888 137.675C44.5415 137.675 53.4204 128.796 53.4204 117.843C53.4204 106.891 44.5415 98.0117 33.5888 98.0117C22.6362 98.0117 13.7573 106.891 13.7573 117.843C13.7573 128.796 22.6362 137.675 33.5888 137.675Z"
            fill="#2F2E41"
          />
          <Path
            d="M30.5765 133.407H24.5518V144.202H30.5765V133.407Z"
            fill="#2F2E41"
          />
          <Path
            d="M42.6263 133.407H36.6016V144.202H42.6263V133.407Z"
            fill="#2F2E41"
          />
          <Path
            d="M29.5724 146.209C32.3452 146.209 34.593 145.366 34.593 144.327C34.593 143.287 32.3452 142.444 29.5724 142.444C26.7996 142.444 24.5518 143.287 24.5518 144.327C24.5518 145.366 26.7996 146.209 29.5724 146.209Z"
            fill="#2F2E41"
          />
          <Path
            d="M41.6222 145.959C44.395 145.959 46.6428 145.116 46.6428 144.076C46.6428 143.036 44.395 142.193 41.6222 142.193C38.8494 142.193 36.6016 143.036 36.6016 144.076C36.6016 145.116 38.8494 145.959 41.6222 145.959Z"
            fill="#2F2E41"
          />
          <Path
            d="M34.0908 119.6C37.8342 119.6 40.8687 116.566 40.8687 112.823C40.8687 109.079 37.8342 106.045 34.0908 106.045C30.3475 106.045 27.313 109.079 27.313 112.823C27.313 116.566 30.3475 119.6 34.0908 119.6Z"
            fill="white"
          />
          <Path
            d="M34.0913 115.082C35.3391 115.082 36.3506 114.07 36.3506 112.823C36.3506 111.575 35.3391 110.563 34.0913 110.563C32.8435 110.563 31.832 111.575 31.832 112.823C31.832 114.07 32.8435 115.082 34.0913 115.082Z"
            fill="#3F3D56"
          />
          <Path
            d="M14.3523 99.3999C12.751 92.2285 17.8697 84.9822 25.7853 83.2147C33.7008 81.4472 41.4158 85.8279 43.0171 92.9993C44.6184 100.171 39.3725 102.816 31.4569 104.583C23.5413 106.351 15.9536 106.571 14.3523 99.3999Z"
            fill="#239C9D"
          />
          <Path
            d="M20.2113 112.891C20.948 111.338 17.5341 108.176 12.5861 105.829C7.63804 103.483 3.02966 102.839 2.29294 104.393C1.55622 105.946 4.97014 109.108 9.91815 111.455C14.8662 113.801 19.4745 114.444 20.2113 112.891Z"
            fill="#2F2E41"
          />
          <Path
            d="M23.8481 124.997C23.8481 126.938 28.8458 130.771 34.3915 130.771C39.9371 130.771 45.1368 125.307 45.1368 123.366C45.1368 121.425 39.9371 123.742 34.3915 123.742C28.8458 123.742 23.8481 123.056 23.8481 124.997Z"
            fill="white"
          />
          <Path
            d="M241.393 141.76H209.731V157.867H241.393V141.76Z"
            fill="#239C9D"
          />
          <Path
            d="M238.915 144.375H207.253V160.482H238.915V144.375Z"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M65.9214 49.9551H56.8843V58.9922H65.9214V49.9551Z"
            fill="#FF6584"
          />
          <Path
            d="M63.6626 46.9419H54.6255V55.979H63.6626V46.9419Z"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M227.448 67.394C238.4 67.394 247.279 58.5151 247.279 47.5625C247.279 36.6098 238.4 27.731 227.448 27.731C216.495 27.731 207.616 36.6098 207.616 47.5625C207.616 58.5151 216.495 67.394 227.448 67.394Z"
            fill="#2F2E41"
          />
          <Path
            d="M235.107 72.9619L241.035 71.8887L239.112 61.2669L233.184 62.3401L235.107 72.9619Z"
            fill="#2F2E41"
          />
          <Path
            d="M223.251 75.1089L229.179 74.0356L227.256 63.4139L221.328 64.4871L223.251 75.1089Z"
            fill="#2F2E41"
          />
          <Path
            d="M226.398 77.3443C228.514 75.5524 229.684 73.4564 229.012 72.6629C228.34 71.8694 226.08 72.6789 223.964 74.4709C221.848 76.2629 220.678 78.3588 221.35 79.1523C222.022 79.9458 224.282 79.1363 226.398 77.3443Z"
            fill="#2F2E41"
          />
          <Path
            d="M238.008 75.2425C240.124 73.4505 241.294 71.3546 240.622 70.5611C239.951 69.7676 237.69 70.5771 235.574 72.3691C233.458 74.1611 232.288 76.257 232.96 77.0505C233.632 77.844 235.892 77.0345 238.008 75.2425Z"
            fill="#2F2E41"
          />
          <Path
            d="M226.06 49.4898C229.803 49.4898 232.837 46.4553 232.837 42.7119C232.837 38.9686 229.803 35.9341 226.06 35.9341C222.316 35.9341 219.282 38.9686 219.282 42.7119C219.282 46.4553 222.316 49.4898 226.06 49.4898Z"
            fill="white"
          />
          <Path
            d="M223.274 42.5415C224.522 42.5415 225.533 41.53 225.533 40.2822C225.533 39.0345 224.522 38.0229 223.274 38.0229C222.026 38.0229 221.015 39.0345 221.015 40.2822C221.015 41.53 222.026 42.5415 223.274 42.5415Z"
            fill="#3F3D56"
          />
          <Path
            d="M243.092 25.9878C243.39 18.6459 237.063 12.4273 228.959 12.0981C220.855 11.7689 214.044 17.4538 213.746 24.7958C213.447 32.1377 219.081 33.8058 227.184 34.135C235.288 34.4642 242.794 33.3298 243.092 25.9878Z"
            fill="#239C9D"
          />
          <Path
            d="M218.802 46.1652C219.186 44.4894 215.17 42.1391 209.832 40.9156C204.494 39.6921 199.855 40.0587 199.471 41.7344C199.087 43.4101 203.103 45.7604 208.441 46.984C213.779 48.2075 218.417 47.8409 218.802 46.1652Z"
            fill="#2F2E41"
          />
          <Path
            d="M257.73 52.6381C258.114 50.9623 254.098 48.612 248.76 47.3885C243.422 46.165 238.784 46.5316 238.4 48.2073C238.015 49.883 242.031 52.2333 247.369 53.4569C252.707 54.6804 257.346 54.3138 257.73 52.6381Z"
            fill="#2F2E41"
          />
          <Path
            d="M232.894 55.378C233 55.9619 232.99 56.5609 232.864 57.1408C232.738 57.7207 232.499 58.2701 232.161 58.7577C231.823 59.2453 231.392 59.6616 230.893 59.9827C230.394 60.3038 229.837 60.5235 229.253 60.6292C228.669 60.7349 228.07 60.7245 227.49 60.5988C226.91 60.473 226.361 60.2342 225.873 59.896C225.386 59.5579 224.969 59.127 224.648 58.628C224.327 58.129 224.108 57.5717 224.002 56.9878C223.557 54.5321 225.456 53.6632 227.912 53.2187C230.367 52.7741 232.45 52.9223 232.894 55.378Z"
            fill="white"
          />
          <Path
            d="M178.886 24.8518L201.73 42.424"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M168.092 34.1401C177.52 34.1401 185.162 26.4975 185.162 17.0699C185.162 7.64233 177.52 -0.000244141 168.092 -0.000244141C158.665 -0.000244141 151.022 7.64233 151.022 17.0699C151.022 26.4975 158.665 34.1401 168.092 34.1401Z"
            fill="#FF6584"
          />
          <Path
            d="M227.423 169.392C228.159 163.966 227.374 159.379 225.671 159.148C223.967 158.917 221.99 163.129 221.254 168.556C220.519 173.983 221.303 178.569 223.007 178.8C224.711 179.031 226.688 174.819 227.423 169.392Z"
            fill="#2F2E41"
          />
          <Path
            d="M17.2738 200.752C19.1712 200.752 20.7093 199.214 20.7093 197.317C20.7093 195.419 19.1712 193.881 17.2738 193.881C15.3765 193.881 13.8384 195.419 13.8384 197.317C13.8384 199.214 15.3765 200.752 17.2738 200.752Z"
            fill="#239C9D"
          />
          <Path
            d="M73.4527 193.294H64.4155V202.332H73.4527V193.294Z"
            fill="#FF6584"
          />
          <Path
            d="M64.4677 202.761C66.365 202.761 67.9031 201.223 67.9031 199.326C67.9031 197.428 66.365 195.89 64.4677 195.89C62.5703 195.89 61.0322 197.428 61.0322 199.326C61.0322 201.223 62.5703 202.761 64.4677 202.761Z"
            fill="#239C9D"
          />
          <Path
            d="M115.966 67.4539C117.864 67.4539 119.402 65.9158 119.402 64.0185C119.402 62.1211 117.864 60.583 115.966 60.583C114.069 60.583 112.531 62.1211 112.531 64.0185C112.531 65.9158 114.069 67.4539 115.966 67.4539Z"
            fill="#239C9D"
          />
          <Path
            d="M182.681 172.154C183.587 172.154 184.322 171.419 184.322 170.513C184.322 169.607 183.587 168.873 182.681 168.873C181.775 168.873 181.041 169.607 181.041 170.513C181.041 171.419 181.775 172.154 182.681 172.154Z"
            fill="#FF6584"
          />
          <Path
            d="M190.719 197.743V179.064"
            stroke="#3F3D56"
            strokeWidth="0.502064"
            strokeMiterlimit="10"
          />
          <Path
            d="M190.719 181.705C192.178 181.705 193.36 180.523 193.36 179.064C193.36 177.605 192.178 176.422 190.719 176.422C189.26 176.422 188.077 177.605 188.077 179.064C188.077 180.523 189.26 181.705 190.719 181.705Z"
            fill="#3F3D56"
          />
          <Path
            d="M190.719 190.577C190.719 190.577 190.341 182.461 182.605 183.404L190.719 190.577Z"
            fill="#3F3D56"
          />
        </G>
        <Defs>
          <ClipPath id={filterId}>
            <Rect width="280.13" height="209" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
}
